import { render, staticRenderFns } from "./candidate-modal.vue?vue&type=template&id=6051236c&scoped=true&"
import script from "./candidate-modal.vue?vue&type=script&lang=js&"
export * from "./candidate-modal.vue?vue&type=script&lang=js&"
import style0 from "./candidate-modal.vue?vue&type=style&index=0&id=6051236c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051236c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6051236c')) {
      api.createRecord('6051236c', component.options)
    } else {
      api.reload('6051236c', component.options)
    }
    module.hot.accept("./candidate-modal.vue?vue&type=template&id=6051236c&scoped=true&", function () {
      api.rerender('6051236c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/candidate-modal.vue"
export default component.exports